import { Component, OnInit } from '@angular/core';
import { LoadingService } from './shared/loading/loading.service';
import { EventsService } from './shared/events/events.service';
import '../style/app.scss';

@Component({
  selector: 'my-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
})

export class AppComponent implements OnInit {
    public infoMessage: boolean;
    public errorMessage: boolean;
    public messageText: string;

  constructor(public loadingService: LoadingService, public eventsService: EventsService) {
    this.infoMessage = false;
  }

  closeInfoMessage() {
    this.infoMessage = false;
    this.errorMessage = false;
    this.messageText = '';
  }

  ngOnInit() {
    this.eventsService.on( 'showAlert', (data) => {
      this.infoMessage = data.infoMessage;
      this.errorMessage = data.errorMessage;
      this.messageText = data.messageText;
      setTimeout(() => {
        this.closeInfoMessage();
      }, 5000);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/app.component.ts